module.exports = __webpack_public_path__ + "static/media/step_6.160e9e23.png";